import classNames from 'classnames';

import { ReactComponent as ArcLoading } from '../../../../svgIcons/arc-loading.svg';

import { IProcessingWidget } from './types';
import useStyles from './styles';

function ProcessingWidget({
  children,
  loaderContainerClassName,
  text,
  loading,
}: IProcessingWidget) {
  const classes = useStyles();

  return (
    <>
      {loading ? (
        <div className={classNames(classes.loaderContainer, loaderContainerClassName)}>
          <ArcLoading className={classes.loader} />
          <div className={classes.text}>{text}</div>
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  );
}

export default ProcessingWidget;
